/**
 * 职称枚举
 */
export default Object.freeze(['正高级工程师',
    '高级工程师',
    '工程师',
    '助理工程师',
    '正高级经济师',
    '高级经济师',
    '经济师',
    '助理经济师',
    '高级政工师',
    '政工师',
    '助理政工师',
    '正高级会计师',
    '高级会计师',
    '会计师',
    '助理会计师',
    '高级审计师',
    '审计师',
    '助理审计师',
    '其他'])